import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {PoslovniUgovorDocument} from "./PoslovniUgovorDocument";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, tip ugovora, partner, sektor
// opciono: opis, lista priloga

export const poslovniUgovorDocumentFields: IntercateKeysMap<PoslovniUgovorDocument, EntityField<PoslovniUgovorDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	contractType: {
		name: "contractType", dataType: EntityFieldDataType._string, label: "Tip ugovora",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<PoslovniUgovorDocument>> = [
	poslovniUgovorDocumentFields.indexingNumber,
	poslovniUgovorDocumentFields.indexingDate,
	poslovniUgovorDocumentFields.documentNumber,
	poslovniUgovorDocumentFields.documentDate,
	poslovniUgovorDocumentFields.assignedTo,
	poslovniUgovorDocumentFields.clientId,
	poslovniUgovorDocumentFields.sectorId,
	poslovniUgovorDocumentFields.contractType,
	poslovniUgovorDocumentFields.tags,
	poslovniUgovorDocumentFields.description,
	poslovniUgovorDocumentFields.parentId
]

export const poslovniUgovorDocumentFieldsDescriptor: EntityFieldsDescriptor<PoslovniUgovorDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
